import { Typography } from '@mui/material'
import { RoomTypes } from '@weblite/ts-action/room'
import { styled } from '@mui/material/styles'
import { BotIcon, ChannelIcon, GroupIcon, StationsIcon } from '$common/icons'
import { VerifiedAccount } from '$common/icons/verified-account'
import { t } from '$i18n'
import { EducationalIcon } from '$common/icons/educational'

const StyledVerifiedIcon = styled(VerifiedAccount)`
  margin-right: 4px;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.palette.primary500};
`

interface Props {
  title: string
  roomType?: RoomTypes
  verified?: boolean
  hasDeleted?: boolean
  isMookeb?: boolean
  isEducational?: boolean
}

export function Title({
  roomType,
  title,
  verified = false,
  hasDeleted = false,
  isMookeb = false,
  isEducational = false,
}: Props) {
  const isGroup = roomType === 'GROUP'
  const isChannel = roomType === 'CHANNEL'
  const isWappRoom = roomType === 'WAPP_ROOM'

  return (
    <>
      {isGroup ? (
        <GroupIcon
          sx={{ color: 'primary.main', width: '20px', height: '20px' }}
        />
      ) : isChannel ? (
        isMookeb ? (
          <StationsIcon
            sx={{ color: 'primary.main', width: '20px', height: '20px' }}
          />
        ) : isEducational ? (
          <EducationalIcon
            sx={{ color: 'primary.main', width: '20px', height: '20px' }}
          />
        ) : (
          <ChannelIcon
            sx={{ color: 'primary.main', width: '20px', height: '20px' }}
          />
        )
      ) : isWappRoom ? (
        <BotIcon
          sx={{ color: 'primary.main', width: '20px', height: '20px' }}
        />
      ) : null}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          marginLeft: 'auto',
        }}
      >
        <Typography
          variant="subtitle2"
          component="span"
          color="neutral1000"
          className="chat-list-item--title"
        >
          {hasDeleted ? t('accounts.deletedAccount') : title}
        </Typography>

        {verified && !hasDeleted && <StyledVerifiedIcon />}
      </div>
    </>
  )
}
